import React from "react";
import { SpinnerWrapper } from "./CommonStyles";
import Colors from "../../themes/Colors";

const Spinner = ({
  size = 40,
  colorBorder,
  colorBorderTop,
  ariaLabel = "spinner",
  testid,
}) => {
  return (
    <SpinnerWrapper
      size={size}
      colorBorder={colorBorder || Colors.white}
      colorBorderTop={colorBorderTop || Colors.primaryHumano}
      aria-label={ariaLabel}
      testid={testid}
    />
  );
};

export default Spinner;